<template>
  <div class="product-cantainer">
    <div class="product-main">
      <div class="product-img">
        <div class="prod-img-top">
          <div class="show-img">
            <transition name="fade">
              <el-image
                  :src="nowImg"
                  class="goodImg"
                  :key="nowIndex"
                  :preview-src-list="imgList"
                  style="height: 90%;">
                </el-image>
            </transition>
          </div>
          <div class="img-list" v-if="imgList.length>1">
            <img v-for="(item,index) in imgList" :key="index" :src="item" @click="switchImg(index)"
            @mouseover="switchImg(index)"
            :style="nowIndex == index?'border:1px solid #1077FF':''"/>
          </div>
        </div>
      </div>
      <div class="product-details">
        <div class="prod-title-box">
          <p class="prod-title">{{msg.itemTitle}}</p>
        </div>
        <div class="prod-info">
          <div class="prod-info-price">
            <span>￥</span>{{msg.price}}
          </div>
          <ul
          style="margin-top: 10px;line-height: 25px;font-size: 14px;
          padding-bottom: 10px;border-bottom: 1px solid #ccc;">
            <li>
              预售，7天内发货 | 快递:免运费
            </li>
            <li>退货宝 | 7天内无理由退货 | 极速退款</li>
            <li>材料供应商：{{msg.supplier || ''}}</li>
          </ul>
          <div style="margin: 10px 0;">
            规格
          </div>
          <div class="prod-info-detail">
            <div class="model-title" v-for="(val,i) in product.spu"
             v-if="val!=''" :style="labelNum==i?'color: #FF5300;border:1px solid #FF5300;':''"
             @click="clickGoods(i,val)">
             {{val}}
            </div>
          </div>
        </div>
        <div class="statistics">
          <span>数量选择</span>
          <el-input-number v-model="productNum" :min="1" :max="999" style="margin-left: 50px;width: 130px;"></el-input-number>
          <span style="color: #8d9ba8;">
          有货
          </span>
        </div>
        <div class="prod-total">
          <span> 合计  ￥<span class="total-txt">{{msg.price*productNum}}</span> 元</span>
        </div>
        <div style="border: 1px white solid;margin-top: 20px;width:100%;height: 15%;">
          <el-button class="myBtn" @click="openDialog">立即购买</el-button>
          <!-- <el-button class="myBtn" @click="submitForm">立即购买</el-button> -->
        </div>
      </div>
    </div>
    <!-- <div class="prod-show">
      <p class="prod-show-title">商品详情</p>
      <p style="font-size: 18px;font-weight: 600;margin-top: 10px;">{{msg.title}}</p>
      <div style="width: 100%;height: 60px;margin-top: 20px;display: flex;" v-for="(val,i) in product.spu">
       <div style="border: 1px solid #F3F6F8;">
          <div class="tableTr">{{val.name}}</div>
          <div class="tableTd">
            <p>
              <span v-for="(item,index) in val.item"><span v-if="index">,</span>{{item.name}}</span>
            </p>
          </div>
        </div>
      </div>
      <div class="prod-info-list">
        <ul>
        </ul>
      </div>
    </div> -->
    <!-- 二维码/订单确认弹窗 -->
    <el-dialog
      title="订单详情"
      :visible.sync="dialogFlag"
      width="800px"
      center
      class="order-dialog">

      <div class="order-content">
        <!-- 订单总览 -->
        <div class="order-summary">
          <div class="summary-title">{{msg.itemTitle}}</div>
          <div class="summary-price">
            <span class="price-symbol">¥</span>
            <span class="price-number">{{ actualPayment }}</span>
          </div>
        </div>

        <!-- 费用明细 -->
        <div class="fee-details">
          <div class="fee-item">
            <span class="fee-label">订单金额</span>
            <span class="fee-value">¥{{ (msg.price * productNum).toFixed(2) }}</span>
          </div>
          <div class="fee-item">
            <span class="fee-label">数量</span>
            <span class="fee-value">{{ productNum }}</span>
          </div>
          <div class="fee-item">
            <span class="fee-label">当前积分</span>
            <span class="fee-value">{{ user.balance }}</span>
          </div>
          <div class="fee-item">
            <span class="fee-label">实付金额</span>
            <span class="fee-value final">¥{{ actualPayment }}</span>
          </div>
        </div>

        <!-- 备注输入栏 -->
        <div class="remark-box">
          <span class="label">订单备注：</span>
          <el-input
            type="textarea"
            :rows="3"
            placeholder="请输入备注信息（如：颜色、尺码特殊要求等）"
            v-model="msg.remark"
            maxlength="200"
            show-word-limit
            style="margin-top: 5px;">
          </el-input>
        </div>
      </div>

      <!-- 底部按钮 -->
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFlag = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确认订单</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
export default{
  data(){
    return{
      num:1,
      imgList:[],
      nowImg:'',
      nowIndex: 0,
      loading: false,
      isHovering: true,
      productNum: 0,
      msg:{},
      product:{},
      dialogFlag:false,
      detailMsg:'',
      sideShow:false,
      labelNum:0,
      labelName:'',
    }
  },
  computed: {
    ...mapState(['user']),
    actualPayment() {
      const total = this.msg.price * this.productNum;
      // 防止实付金额为负数
      // const payment = this.user.balance - total;
      const payment = total;
      return payment > 0 ? payment.toFixed(2) : '0.00';
    }
  },
  mounted() {
    this.handleScroll(); // 初始化时检查一次
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods:{
    loadDataList(){
      var data = JSON.parse(this.$route.query.data)
      this.imgList.push(data.itemImage)
      this.msg = data
      this.nowImg = this.imgList[0];
      let list = data.itemPoint.split(" ")
      this.product.spu = list
      this.labelName = this.product.spu[0]
      return false
      var data = JSON.parse(this.$route.query.data)
      data.images.forEach(val=>{
        this.imgList.push(this.$yxz.oss_img(val))
      })
      this.nowImg = this.imgList[0];
      this.msg = data
      this.detailMsg = data.content.replace(/<[^>]*>/g, '');
      this.$api.get({
        url:'/product/goods/' + data.id
      }).then(res=>{
        // 商品详情赋值
        this.product = JSON.parse(res.msg).data
        this.labelName = this.product.spu[0].item[0].name
      })
    },
    switchImg(index){
      this.nowIndex = index
      this.nowImg = this.imgList[index]
    },
    switchGoods(i,name){
      this.labelNum = i
      this.labelName = name
    },
    openDialog(){
      this.dialogFlag = true
    },
    submitForm(){
      if (!this.user.isLogin) {
        this.$message.warning('请先登录后再购买')
        this.$router.push('/login')
        return
      }
      const orderData = {
        goodsId: this.msg.itemId,
        number: this.productNum,
        price: this.msg.price,
        title: this.msg.itemTitle,
        supplier: this.msg.supplier,
        image: this.msg.itemImage,
        actualPayment: (this.msg.price * this.productNum).toFixed(2),
        difference:this.product.spu[this.labelNum],
        itemRemark:this.msg.remark,//备注
      }
      this.$api.post({
        url: '/biz/mall/order/add',
        data: orderData
      }).then(res => {
        if (res.code==200) {
          this.$message.success('下单成功！')
          this.dialogFlag = false
        } else {
          this.$message.error('下单失败，请重试')
        }
      }).catch(err => {
        console.error('下单错误:', err)
        this.$message.error('下单失败，请重试')
      })
    },
     handleScroll() {
       const windowHeight = window.innerHeight || document.documentElement.clientHeight;
       const bodyScrollTop = window.pageYOffset || document.documentElement.scrollTop;
       const docHeight = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
       // const offset = 100; // 距离顶部和底部多少像素时显示或隐藏盒子
       const topOffset = 600
       const botOffset = 100

       // 判断是否到达顶部或底部的条件
       const nearTop = bodyScrollTop >= topOffset;
       const nearBottom = docHeight - (bodyScrollTop + windowHeight) <= botOffset;

       // 根据条件更新sideShow的值
       this.sideShow = nearTop && !nearBottom;
     },
     clickGoods(i,val){
      this.labelNum = i;
      this.msg.difference = val;
    },
  },
  created(){
    this.isHovering = false
    this.loadDataList();
  },
}
</script>

<style scoped>
.product-cantainer{
  width: 100%;
  height: auto;
  background-color: #FFFFFF;
}
.product-main{
  width: 63%;
  height: 700px;
  margin: 30px auto;
  position: relative;
}
.product-img{
  width:50%;
  height:100%;
  float:left;
}
.prod-img-top{
  width: 100%;
  height: 100%;
  clear:both;
}
.product-details{
  width:48%;
  height:auto;
  float:left;
  margin-left: 2%;
}
.prod-title-box{
  width: 100%;
  /* height: 15%; */
  font-size: 20px;
  line-height:40px;
  color: black;
  .prod-title{
    font-size: 25px;
    font-weight: 550;
  }
  }
.prod-info{
  width: 100%;
  height: auto;
  .prod-info-price{
    width: 100%;
    height: 25%;
    line-height: 50px;
    color: #FF664E;
    font-size: 25px;
    font-weight: 700;
    span{
      font-size: 15px;
    }
  }
  .prod-info-detail{
    width: 100%;
    height: auto;
    margin-top: 2%;
    font-size: 13px;
    overflow: hidden;
    .info-detail{
      width: 100%;
      height: 50%;
      .detail-item{
        width: 33.33%;
        height: 50%;
        float: left;
      }
    }
    .model-title{
      line-height: 20px;
      float: left;
      margin: 10px;
      padding: 5px;
      border: 1px solid #ccc;
      border-radius: 5px;
     }
  }
}
.prod-total{
  margin-top: 15px;
  width: 100%;
  height: 17%;
  .prod-total-txt{
    line-height: 100px;
  }
}
.total-txt{
  font-size: 25px;
  color: #FF664E;
}
.img-list{
  width: 65%;
  height: 13%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 2% 17%;
  img{
    height: auto;
    flex-shrink: 0;
    max-width: 25%;
    height: 100%;
    object-fit: cover;
  }
}
.show-img{
  width:90%;
  height: 76%;
  display: flex;
  overflow: hidden;
  .goodImg{
    margin: 0 auto;
    cursor: crosshair;
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
.statistics{
  height: 50px;
  margin-top: 20px;
  border: 1px solid rgba(243,243,243,0.3);
  line-height: 50px;
}
.myBtn{
  width: 100%;
  height: 100%;
  color: white;
  font-size: 18px;
  border-radius: 5px;
  background-color: #007aff;
}
.order_info{
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* 弹窗内容样式 */
.order-content {
  padding: 10px 0;
}

.order_info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  font-size: 14px;
  line-height: 1.5;
}

.order_info .label {
  color: #606266;
  font-weight: 500;
}

.order_info .value {
  color: #303133;
  font-weight: bold;
  max-width: 60%;
  text-align: right;
}

.total-row {
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px dashed #EBEEF5;
}

.final-price {
  font-size: 18px;
  color: #FF5300;
}

.remark-box {
  margin-top: 15px;
}

.remark-box .label {
  display: block;
  margin-bottom: 5px;
  color: #606266;
  font-weight: 500;
  font-size: 14px;
}

.dialog-footer {
  text-align: right;
  padding: 10px 20px 0;
}

/* 订单总览 */
.order-summary {
  text-align: center;
  margin-bottom: 20px;
}

.order-summary .summary-title {
  font-size: 16px;
  color: #303133;
  margin-bottom: 8px;
}

.order-summary .summary-price {
  font-size: 32px;
  font-weight: bold;
  color: #303133;
  line-height: 1;
}

.order-summary .price-symbol {
  font-size: 24px;
}

.order-summary .price-number {
  font-size: 32px;
  font-weight: bold;
  color: #303133;
}

/* 费用明细 */
.fee-details {
  margin-bottom: 20px;
}

.fee-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #EBEEF5;
  font-size: 14px;
}

.fee-item:last-child {
  border-bottom: none;
}

.fee-item .fee-label {
  color: #606266;
}

.fee-item .fee-value {
  color: #303133;
  font-weight: 500;
}

.fee-item .discount {
  color: #FF664E;
}

.fee-item.total .fee-label {
  font-weight: bold;
  color: #303133;
}

.fee-item.total .fee-value {
  color: #FF5300;
  font-weight: bold;
}

</style>



// WEBPACK FOOTER //
// productDetails.vue?983d7588